export default "__VITE_ASSET__H__9Z9Cy__"